import React from 'react';
import { withTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import MultiInputFilter, { InputProperty } from '../../../components/Filters/MultiInputFilter';
import { FilterProps } from './FilterProps';

export type DepartureArrivalFilterProps = FilterProps

const getLabel = (t: TFunction, departure: string | null, arrival: string | null) => {
    if (departure && arrival) {
        return t(`orders.filter.itinerary_departure_address.label_departure_and_arrival`, { departure, arrival });
    }
    if (departure) {
        return t(`orders.filter.itinerary_departure_address.label_departure`, { departure });
    }
    if (arrival) {
        return t(`orders.filter.itinerary_departure_address.label_arrival`, { arrival });
    }
    return t(`orders.filter.itinerary_departure_address.label_empty`);
};

const DepartureArrivalFilter = (
    {
        queryParams,
        t,
        onChange,
    }: DepartureArrivalFilterProps
) => {
    const departure: InputProperty =  {
        name: 'itinerary_departure_address',
        label: t('orders.filter.itinerary_departure_address.departure.label'),
        placeholder: t('orders.filter.itinerary_departure_address.departure.placeholder'),
        type: 'text',
        value: queryParams.get('itinerary_departure_address') || '',
    };
    const arrival: InputProperty =  {
        name: 'itinerary_arrival_address',
        label: t('orders.filter.itinerary_departure_address.arrival.label'),
        placeholder: t('orders.filter.itinerary_departure_address.arrival.placeholder'),
        type: 'text',
        value: queryParams.get('itinerary_arrival_address') || '',
    };
    const fields=[departure, arrival];
    return (
        <MultiInputFilter
            name="itinerary_departure_address"
            title={t('orders.filter.itinerary_departure_address.title')}
            label={
                getLabel(
                    t,
                    queryParams.get('itinerary_departure_address'),
                    queryParams.get('itinerary_arrival_address')
                )
            }
            onApply={(keyValues) => {
                
                const filter: { [key: string]: string[] } = {};
                Object.entries(keyValues).forEach(([key, value]) => {
                    filter[key] =  value? [value]: [];
                }, {});
                onChange(filter);
            }}
            onDelete={(_) => {
                onChange(
                    fields.reduce((acc, field) => ({
                        ...acc,
                        [field.name]: [],
                    }), {})
                );
            }}
            fields={fields}
        />
    );
};

export default withTranslation()(DepartureArrivalFilter);
